module.exports = __webpack_public_path__ + "static/media/icon-info.d873380f.svg";